import { EInputTypes, InputDate, InputTextCustom } from "medere-ui-framework"
import PaymentMethod, { PaymentOrderMethod } from "./PaymentOrderMethod"
import React, { Dispatch, SetStateAction } from "react"
import { Button } from "primereact/button"
import { isNullOrEmpty } from "../../utils/utils"
import Big from "big.js"
import { MAX_DECIMAL } from "../../interface/orderOfProvision"

const BasePaymentMethod = ({ children, onClick, paymentOrderMethod, setPaymentOrderMethod }: { children: React.ReactNode, onClick: () => void, paymentOrderMethod: PaymentOrderMethod, setPaymentOrderMethod: Dispatch<SetStateAction<PaymentOrderMethod>> }) => (
    <div className="flex md:flex-row flex-column gap-4 align-items-end">
        {children}
        <InputTextCustom
            label="Observaciones"
            value={paymentOrderMethod.observations}
            onChange={(e) =>
                setPaymentOrderMethod((prev) => ({ ...prev, observations: e.target.value }))
            }
        />
        <InputTextCustom
            inputType={EInputTypes.NUMBER}
            label="Importe"
            maxFractionDigits={MAX_DECIMAL}
            value={Number(paymentOrderMethod.amount)}
            onChange={(e) => {
                setPaymentOrderMethod((prev) => ({ ...prev, amount: Big(e?.target?.value ? e.target.value : 0) }))
            }}
        />
        <Button className="buttonMain capitalize w-full" label="agregar" onClick={onClick} />
    </div>
)

type PaymentMethodProps = {
    paymentOrderMethod: PaymentOrderMethod
    setPaymentOrderMethod: Dispatch<SetStateAction<PaymentOrderMethod>>
    children: React.ReactNode
    onClick: () => void
}


const DebitPaymentMethod = ({ paymentOrderMethod, setPaymentOrderMethod, children, onClick }: PaymentMethodProps) => {
    return (
        <BasePaymentMethod
            onClick={onClick}
            paymentOrderMethod={paymentOrderMethod}
            setPaymentOrderMethod={setPaymentOrderMethod}
        >
            {children}
            <InputDate
                value={paymentOrderMethod.paymentDate}
                onChange={(e) =>
                    setPaymentOrderMethod((prev) => ({ ...prev, paymentDate: e.value }))
                }
                label="Fecha de pago"
            />
            <InputTextCustom
                inputType={EInputTypes.NUMBER}
                label="Nº de comprobante"
                value={paymentOrderMethod.formNumber}
                onChange={(e) =>
                    setPaymentOrderMethod((prev) => ({ ...prev, formNumber: e.target.value }))
                }
            />
        </BasePaymentMethod>
    )
}

const CheckPaymentMethod = ({ paymentOrderMethod, setPaymentOrderMethod, children, onClick }: PaymentMethodProps) => {
    return (
        <BasePaymentMethod
            onClick={onClick}
            paymentOrderMethod={paymentOrderMethod}
            setPaymentOrderMethod={setPaymentOrderMethod}
        >
            {children}
            <InputDate
                value={paymentOrderMethod.paymentDate}
                onChange={(e) =>
                    setPaymentOrderMethod((prev) => ({ ...prev, paymentDate: e.value }))
                }
                label="Fecha de pago"
            />
            <InputTextCustom
                inputType={EInputTypes.NUMBER}
                label="Nº de cheque"
                value={paymentOrderMethod.checkNumber}
                onChange={(e) =>
                    setPaymentOrderMethod((prev) => ({ ...prev, checkNumber: e.target.value }))
                }
            />
        </BasePaymentMethod>
    )
}

const CashPaymentMethod = ({ paymentOrderMethod, setPaymentOrderMethod, children, onClick }: PaymentMethodProps) => {
    return (
        <BasePaymentMethod
            onClick={onClick}
            paymentOrderMethod={paymentOrderMethod}
            setPaymentOrderMethod={setPaymentOrderMethod}
        >
            {children}
            <InputDate
                value={paymentOrderMethod.paymentDate}
                onChange={(e) =>
                    setPaymentOrderMethod((prev) => ({ ...prev, paymentDate: e.value }))
                }
                label="Fecha de pago"
            />
        </BasePaymentMethod>
    )
}

export { DebitPaymentMethod, CheckPaymentMethod, CashPaymentMethod }